import {ASPECT_RATIO} from "../constants/aspectRatio";

export const getHeightWithRatio = (width: number, isHorizontal?: boolean) => {
    return (isHorizontal ? width  / ASPECT_RATIO : width * ASPECT_RATIO).toFixed(2)
}

export const getWidthWithRatio = (height: number, isHorizontal?: boolean) => {
    return (isHorizontal ? height * ASPECT_RATIO : height / ASPECT_RATIO).toFixed(2)
}import {ASPECT_RATIO} from "../constants/aspectRatio";

export const getHeightWithRatio = (width: number, isHorizontal?: boolean) => {
    return (isHorizontal ? width  / ASPECT_RATIO : width * ASPECT_RATIO).toFixed(2)
}

export const getWidthWithRatio = (height: number, isHorizontal?: boolean) => {
    return (isHorizontal ? height * ASPECT_RATIO : height / ASPECT_RATIO).toFixed(2)
}